var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"list-filter-title"},[_vm._v(_vm._s(_vm.param.name))]),_c('el-date-picker',{attrs:{"clearable":"","type":"date","value-format":"yyyy-MM-dd","placeholder":"Wybierz datę"},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }